/* CUSTOM: Sortiment-Seite – sanftes Einblenden beim Scrollen (bz-*) */
(function () {
  if (window.__bzReveal) return;
  window.__bzReveal = true;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('bz-js');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function scan(scope) {
    (scope || document).querySelectorAll('[data-bz-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  /* Theme-Editor: neu geladene Sektionen sofort sichtbar machen */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bz-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
